import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client/react';

const PROCESS_OVERFLOW_INTERESTS = gql`
    mutation ProcessOverflowInterests($processOverflowInterestsRequest: ProcessOverflowInterestsRequestDto!) {
        processOverflowInterests(processOverflowInterestsRequest: $processOverflowInterestsRequest)
    }
`;

const useProcessOverflowInterests = () => {
    const [mutate, { loading, error }] = useMutation(PROCESS_OVERFLOW_INTERESTS);

    const processOverflowInterests = async (consultantUuid, year, month) => {
        return mutate({
            variables: {
                processOverflowInterestsRequest: {
                    consultantUuid,
                    year: year ?? null,
                    month: month ?? null,
                },
            },
        });
    };

    return {
        processOverflowInterests,
        loading,
        error,
    };
};

export default useProcessOverflowInterests;
